import AbstractProductVariationsView from "./AbstractProductVariationsView";

export default class ProductVariationsRadio extends AbstractProductVariationsView
{
    public set(groupId: string, optionId: string, optionValue: string, parent: Element = null): void
    {
        if (!parent) {
            parent = document.documentElement;
        }

        let selector = this.createSelector(groupId, optionId) + `[value="${optionValue}"]`;
        let input = parent.querySelector(selector) as HTMLInputElement;
        
        if (input) {
            input.checked = true;
        }
    }

    public createSelector(groupId: string, optionId: string): string
    {
        return `input.${this.htmlOptionClass}[name="${this.createOptionName(groupId, optionId)}"]`;
    }

    public changeItemsActivity(parent: Element, enabledValues: Number[])
    {
        parent.querySelectorAll('.' + this.htmlOptionClass).forEach(item => {
            let input = item as HTMLInputElement;

            if (input.checked) {
                return;
            }

            if (enabledValues.includes(Number(input.value))) {
                input.removeAttribute('disabled');
            } else {
                input.setAttribute('disabled', '');
                input.checked = false;
            }
        });
    }
}
